import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import '../../styles/common/PostSuccessMessage.css';

const PostSuccessMessage = ({ isVisible, onClose, autoClose = true, autoCloseDelay = 4000 }) => {
  useEffect(() => {
    if (isVisible && autoClose) {
      const timer = setTimeout(() => {
        onClose();
      }, autoCloseDelay);

      return () => clearTimeout(timer);
    }
  }, [isVisible, autoClose, autoCloseDelay, onClose]);

  if (!isVisible) return null;

  return (
    <div className="post-success-overlay">
      <div className="post-success-message">
        <div className="success-icon-container">
          <FontAwesomeIcon icon={faCheckCircle} className="success-icon" />
        </div>
        
        <div className="success-content">
          <h3 className="success-title">Post Published Successfully!</h3>
          <p className="success-description">
            Your post is now available to members in the Yesod app. Community members can view, interact, and engage with your content.
          </p>
        </div>

        <button 
          className="success-close-btn"
          onClick={onClose}
          aria-label="Close success message"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>

        {autoClose && (
          <div className="success-progress-bar">
            <div 
              className="progress-fill" 
              style={{ animationDuration: `${autoCloseDelay}ms` }}
            ></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PostSuccessMessage;